var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jm-page" },
    [
      _c("div", { staticClass: "jm-back", on: { click: _vm.back } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "jm-back-text" }, [_vm._v("返回")])
      ]),
      _vm._v(" "),
      !_vm.settings.isStart
        ? _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _c("span", [_vm._v("每10分钟进线 3 名客户")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.productModal.handleStart()
                    }
                  }
                },
                [_vm._v("开始")]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.hasProducts
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.productModal.showProducts()
                        }
                      }
                    },
                    [_vm._v("产品须知")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-weight": "bold", color: "black" } },
                    [_vm._v("推荐回复")]
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    on: { change: _vm.changeRecommendReply },
                    model: {
                      value: _vm.settings.isRecommendReply,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isRecommendReply", $$v)
                      },
                      expression: "settings.isRecommendReply"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "font-weight": "bold",
                    color: "black"
                  }
                },
                [_vm._v(_vm._s(_vm.formattedTime))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.stopTrain } },
                [_vm._v("退出")]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "回复数：" +
                    _vm._s(_vm.totalReplyCount) +
                    " 打字速度：" +
                    _vm._s(_vm.typingSpeedWPM) +
                    "字/分钟 "
                ),
                _c("br"),
                _vm._v(
                  "首次响应时间：" +
                    _vm._s(_vm.firstResponseAvgSec) +
                    "秒 平均响应时间：" +
                    _vm._s(_vm.avgResponseSec) +
                    "秒"
                )
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "jm-container" }, [
        _c("img", {
          staticClass: "jm-bg",
          attrs: {
            src: require("@/assets/images/jingmai/jingmai_chat.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "jm-content" },
          [
            _c(
              "el-select",
              {
                staticClass: "status-select",
                attrs: { placeholder: "请选择" },
                model: {
                  value: _vm.settings.onlineStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "onlineStatus", $$v)
                  },
                  expression: "settings.onlineStatus"
                }
              },
              [
                _c("el-option", { attrs: { label: "接待", value: "1" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "离线", value: "2" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "挂起", value: "3" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "train-session-list" },
              _vm._l(_vm.settings.trainSession || [], function(s) {
                return _c(
                  "div",
                  {
                    key: s.id || s.veruser,
                    staticClass: "ts-item",
                    class: {
                      current: s.isCurrent,
                      replied: !s.isCurrent && !s.didReply
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectSession(s)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "ts-avatar",
                      attrs: {
                        src: require("@/assets/images/jingmai/monitorPhoto.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ts-name" }, [
                      _vm._v(_vm._s(s.veruser))
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.currentSession
              ? _c("div", { staticClass: "current-user" }, [
                  _c("div", { staticClass: "ts-item normal" }, [
                    _c("img", {
                      staticClass: "ts-avatar",
                      attrs: {
                        src: require("@/assets/images/jingmai/monitorPhoto.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ts-name" }, [
                      _vm._v(_vm._s(_vm.currentSession.veruser))
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentSession
              ? _c(
                  "div",
                  { ref: "chatContent", staticClass: "chat-msg-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "chat-msg-list" },
                      _vm._l(_vm.currentMessages, function(msg, idx) {
                        return _c(
                          "div",
                          { key: msg.id || idx, staticClass: "msg-item" },
                          [
                            _c("img", {
                              staticClass: "msg-avatar",
                              attrs: {
                                src: require("@/assets/images/jingmai/monitorPhoto.png")
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "msg-main" },
                              [
                                _c("div", { staticClass: "msg-header" }, [
                                  _c("span", { staticClass: "msg-name" }, [
                                    _vm._v(_vm._s(msg.fromName || "对方"))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "msg-time" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatMsgTime(msg.sendTime))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                msg.questionType === "卡片" &&
                                _vm.findOrderById(msg.questionOrderId)
                                  ? _c("order-msg-card", {
                                      attrs: {
                                        order: _vm.findOrderById(
                                          msg.questionOrderId
                                        ),
                                        platform: "jingmai"
                                      }
                                    })
                                  : [
                                      _c("div", {
                                        staticClass: "msg-text",
                                        domProps: {
                                          innerHTML: _vm._s(msg.question)
                                        }
                                      }),
                                      _vm._v(" "),
                                      msg.questionImg
                                        ? _c("img", {
                                            staticClass: "msg-image",
                                            attrs: { src: msg.questionImg }
                                          })
                                        : _vm._e()
                                    ],
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ref-title",
                                    on: {
                                      click: function($event) {
                                        msg.fold = !msg.fold
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        msg.fold
                                          ? "查看参考答案"
                                          : "收起参考答案"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !msg.fold
                                  ? _c(
                                      "div",
                                      { staticClass: "msg-reference" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ref-label" },
                                          [_vm._v("参考回复：")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "ref-body",
                                          domProps: {
                                            innerHTML: _vm._s(msg.answer)
                                          },
                                          on: {
                                            copy: function($event) {
                                              $event.preventDefault()
                                            },
                                            cut: function($event) {
                                              $event.preventDefault()
                                            },
                                            contextmenu: function($event) {
                                              $event.preventDefault()
                                            },
                                            selectstart: function($event) {
                                              $event.preventDefault()
                                            },
                                            dragstart: function($event) {
                                              $event.preventDefault()
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (msg.replyList || []).length
                                  ? _c(
                                      "div",
                                      { staticClass: "reply-list" },
                                      _vm._l(msg.replyList, function(
                                        rep,
                                        rIdx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: rep.id || rIdx,
                                            staticClass: "reply-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "msg-header right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "msg-time" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMsgTime(
                                                          rep.sendTime
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticClass: "msg-avatar",
                                                  attrs: {
                                                    src: require("@/assets/images/jingmai/monitorPhoto.png")
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "msg-text msg-rich"
                                              },
                                              [
                                                _vm._l(
                                                  _vm.parseContent(rep.content),
                                                  function(node, nIdx) {
                                                    return [
                                                      node.type === "img"
                                                        ? _c("img", {
                                                            key: "img-" + nIdx,
                                                            staticClass:
                                                              "msg-image",
                                                            attrs: {
                                                              src: node.src
                                                            }
                                                          })
                                                        : _c(
                                                            "span",
                                                            {
                                                              key:
                                                                "txt-" + nIdx,
                                                              staticStyle: {
                                                                display: "block"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  node.text
                                                                )
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-msg-toolbar" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.closeSession }
                  },
                  [_vm._v("关闭会话")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.sendReply }
                  },
                  [_vm._v("发送")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-msg-input" },
              [
                _c("el-input", {
                  staticClass: "reply-textarea",
                  attrs: {
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入回复内容...",
                    resize: "none"
                  },
                  on: { input: _vm.onReplyInput },
                  nativeOn: {
                    keydown: function($event) {
                      return _vm.onReplyKeydown.apply(null, arguments)
                    },
                    paste: function($event) {
                      return _vm.onReplyPaste.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.replyText,
                    callback: function($$v) {
                      _vm.replyText = $$v
                    },
                    expression: "replyText"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.showQuickReplySuggestions
              ? _c(
                  "div",
                  { staticClass: "quick-reply-suggestions" },
                  _vm._l(_vm.quickReplySuggestions, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "suggestion-item",
                        class: {
                          active: index === _vm.selectedSuggestionIndex
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectSuggestion(item)
                          },
                          mouseenter: function($event) {
                            _vm.selectedSuggestionIndex = index
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "suggestion-text" }, [
                          _vm._v("个")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "suggestion-code" }, [
                          _vm._v(_vm._s(item.quicktext))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "suggestion-content" }, [
                          _vm._v(_vm._s(item.replytext))
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "keyword-input",
              attrs: { placeholder: "搜索短语", clearable: "" },
              on: { input: _vm.onKeywordInput },
              model: {
                value: _vm.keyword,
                callback: function($$v) {
                  _vm.keyword = $$v
                },
                expression: "keyword"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fast-reply-content" },
              _vm._l(_vm.filteredFastReplyList, function(g) {
                return _c("div", { key: g.id, staticClass: "fr-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "fr-group-header",
                      on: {
                        click: function($event) {
                          return _vm.toggleGroup(g.id)
                        },
                        contextmenu: function($event) {
                          $event.preventDefault()
                          return _vm.onGroupContext($event, g)
                        }
                      }
                    },
                    [
                      _c("i", {
                        class: _vm.settings.collapsedGroups[g.id]
                          ? "el-icon-caret-right"
                          : "el-icon-caret-bottom"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "fr-group-title" }, [
                        _vm._v(
                          _vm._s(g.name) +
                            " (" +
                            _vm._s((g.filteredReplyList || []).length) +
                            "/100)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.settings.collapsedGroups[g.id],
                          expression: "!settings.collapsedGroups[g.id]"
                        }
                      ],
                      staticClass: "fr-group-body"
                    },
                    _vm._l(g.filteredReplyList || [], function(r) {
                      return _c(
                        "div",
                        {
                          key: r.id,
                          staticClass: "fr-item",
                          on: {
                            click: function($event) {
                              return _vm.onClickReply(r)
                            },
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.onReplyContext($event, r, g)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "fr-quick" }, [
                            _vm._v(_vm._s(r.quicktext))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "fr-text" }, [
                            _vm._v(_vm._s(r.replytext))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.menu.visible
              ? _c(
                  "div",
                  {
                    staticClass: "fr-menu",
                    style: { left: _vm.menu.x + "px", top: _vm.menu.y + "px" }
                  },
                  [
                    _vm.menu.type === "group"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddGroup }
                            },
                            [_vm._v("添加分组")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditGroup }
                            },
                            [_vm._v("修改")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item danger",
                              on: { click: _vm.menuDeleteGroup }
                            },
                            [_vm._v("删除")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddReply }
                            },
                            [_vm._v("添加短语")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuCollapseAll }
                            },
                            [_vm._v("收起所有")]
                          )
                        ]
                      : _vm.menu.type === "reply"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditReplyGroup }
                            },
                            [_vm._v("修改分组")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddReply }
                            },
                            [_vm._v("添加短语")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditReply }
                            },
                            [_vm._v("修改")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item danger",
                              on: { click: _vm.menuDeleteReply }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fast-reply-actionbars" },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: "刷新", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: { click: _vm.refreshFastReply }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "新建", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: { click: _vm.newFastReply }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "导入", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: {
                        click: function($event) {
                          _vm.showImport = true
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "导出", placement: "bottom" } },
                  [_c("div", { staticClass: "action-item" })]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "下载", placement: "bottom" } },
                  [_c("div", { staticClass: "action-item" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.matchedOrder
              ? _c("div", { staticClass: "orders-list" }, [
                  _c("div", { staticClass: "order-card" }, [
                    _c("div", { staticClass: "order-top" }, [
                      _c("div", { staticClass: "order-no" }, [
                        _vm._v(
                          "订单编号：" + _vm._s(_vm.orderHeader.orderNo) + " "
                        ),
                        _c("i", {
                          staticClass: "el-icon-document-copy copy-icon"
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-time" }, [
                        _vm._v(
                          "下单时间：" + _vm._s(_vm.orderHeader.orderTime) + " "
                        ),
                        _c("br"),
                        _c("span", { staticClass: "pay-time" }, [
                          _vm._v(
                            "付款时间：" + _vm._s(_vm.orderHeader.orderPayTime)
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-header" }, [
                      _c("div", { staticClass: "order-price" }, [
                        _vm._v("¥ " + _vm._s(_vm.matchedOrder.price.toFixed(2)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-meta" }, [
                        _vm._v("数量：" + _vm._s(_vm.matchedOrder.num))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-status" }, [
                        _vm._v(_vm._s(_vm.matchedOrder.status))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-body" }, [
                      _c("img", {
                        staticClass: "order-img",
                        attrs: { src: _vm.matchedOrder.imgurl, alt: "商品图" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "order-title",
                            attrs: { title: _vm.matchedOrder.productName }
                          },
                          [_vm._v(_vm._s(_vm.matchedOrder.productName))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-sku" }, [
                          _vm._v(
                            "SKU：" + _vm._s(_vm.matchedOrder.size || "(无)")
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-pay" }, [
                          _vm._v("支付："),
                          _c("span", { staticClass: "price" }, [
                            _vm._v(
                              "¥ " +
                                _vm._s(
                                  (
                                    _vm.matchedOrder.price *
                                    _vm.matchedOrder.num
                                  ).toFixed(2)
                                )
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-footer" }, [
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("收件人：" + _vm._s(_vm.matchedOrder.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("电话：" + _vm._s(_vm.matchedOrder.phone))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("地址：" + _vm._s(_vm.matchedOrder.address))
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("FastReplyImportDialog", {
              attrs: { sceneId: _vm.sceneId, visible: _vm.showImport },
              on: {
                "update:visible": function($event) {
                  _vm.showImport = $event
                },
                refresh: _vm.refreshFastReply
              }
            }),
            _vm._v(" "),
            _c("FastReplyEditorDialog", {
              attrs: {
                sceneId: _vm.sceneId,
                visible: _vm.showEditor,
                defaultGroupId: _vm.settings.defaultGroupId,
                value: _vm.editorValue
              },
              on: {
                "update:visible": function($event) {
                  _vm.showEditor = $event
                },
                refresh: _vm.refreshFastReply
              }
            }),
            _vm._v(" "),
            _c("TrainScoreDialog", {
              attrs: { result: _vm.trainResult, visible: _vm.showScore },
              on: {
                "update:visible": function($event) {
                  _vm.showScore = $event
                },
                onRestart: _vm.restartTrain,
                onViewResult: _vm.viewResult
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("CourseProductModal", {
        ref: "productModal",
        attrs: { "course-id": _vm.sceneId },
        on: {
          confirm: _vm.startTrain,
          "products-fetched": function($event) {
            _vm.hasProducts = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52c93130", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c93130","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/jingmaiChat.vue
// module id = 1721
// module chunks = 0